import { getPrefixRoute } from "../../../RBACPlugin";

const REACT_APP_API_ENDPOINT = `${process.env.REACT_APP_EID_ADMIN_API_ENDPOINT}/api/v1`;
// const eID_API_ENDPOINT = getPrefixRoute(REACT_APP_API_ENDPOINT) + "/eid";
const eID_API_ENDPOINT = REACT_APP_API_ENDPOINT + "/eid";

export default {

    GENERATE_EID:                             eID_API_ENDPOINT + "/generate",
    GET_LIST_EID_BY_USER:                     eID_API_ENDPOINT + "/list/user",
    VIEW_EID:                                 eID_API_ENDPOINT + "/view",
    GET_EID_INFO_QRCODE:                      eID_API_ENDPOINT + "/qrcode",
    SHARE_EID:                                eID_API_ENDPOINT + "/share",
    CHANGE_EID_STATUS:                        eID_API_ENDPOINT + "/update/status",
}
